import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'map' })
export class MapPipe implements PipeTransform {
  transform<T, K extends keyof T>(value: T[] | null | undefined, field: K): T[K][] {
    return value?.map((item) => item[field]) ?? [];
  }
}
